import React, { FC }                               from 'react';
import { Redirect, Switch, useHistory, useParams } from 'react-router-dom';

import { RouterUtility } from '../../../util';
import { PrivateRoute }  from '../../components/util/routing/PrivateRoute';

import { RouterLocationParams } from '../../../types';
import ProjectsListIndexPage    from '../projects/listings/overviews/project-list/ProjectListIndexPage';
import { UserDetailsPage }      from './details/UserDetailsPage';

const routeTo    = RouterUtility.getRoutePath,
      routePaths = {
	      currentUser: `${ routeTo( 'CURRENT_USER' ) }`,
	      details:     `${ routeTo( 'CURRENT_USER.DETAILS' ) }`,
	      redirect:    `${ routeTo( 'DASHBOARD' ) }`,
      };

const CurrentUserIndexPage: FC = () => {
	
	let history = useHistory(),
	    params  = useParams<RouterLocationParams.CurrentUserProfile>();
	
	return (
		
		<Switch>
			<PrivateRoute path={ routePaths.details } component={ UserDetailsPage }/>
			<PrivateRoute path={ routePaths.currentUser } exact={ true } component={ UserDetailsPage }/>
		</Switch>
	)
};

export default CurrentUserIndexPage;
